import { AppDispatch } from "../store";

export const openModal = (data: Object) => async (dispatch: AppDispatch) =>  {
    dispatch({ type: 'OPEN_MODAL', payload: data })
}

export const closeModal = (data: Object) => async (dispatch: any) =>  {
    dispatch({ type: 'CLOSE_MODAL', payload: data })
}